export enum ContactsEnum {
  Call = 'call',
  Write = 'write',
  Address = 'address',
}
